import { motion } from 'framer-motion';
import { useTheme } from '../../hooks/useTheme'
import { finishContent } from '../../data/finish'

export function StepThree() {
  const theme = useTheme(state => state.getThemeStyles())

  return (
    <div className={theme.components.success.wrapper}>
      <motion.h3
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className={`${theme.components.success.title.base} ${theme.components.success.title.gradient}`}
      >
        {finishContent.title}
      </motion.h3>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.5 }}
        className={theme.components.success.content.wrapper}
      >
        <p className={theme.components.success.content.text.base}>
          {finishContent.messages.success}
        </p>
        <p className={theme.components.success.content.text.base}>
          {finishContent.messages.instructions}
        </p>
        <p className={theme.components.success.content.text.highlight}>
          {finishContent.messages.highlight}
        </p>
      </motion.div>
    </div>
  );
} 